export default __webpack_public_path__ + "static/media/icon_lock.a3f50a56.svg";